document.addEventListener('DOMContentLoaded', function() {
    // Función para formatear números con comas
    function formatearNumero(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
    // Función para animar el contador
    function animarContador(counter) {
        const target = parseInt(counter.getAttribute('data-target'));
        const duration = 2000; // 2 segundos
        const increment = target / (duration / 16);
        let current = 0;
        
        const updateCounter = () => {
            current += increment;
            if (current < target) {
                counter.textContent = '+' + formatearNumero(Math.floor(current));
                requestAnimationFrame(updateCounter);
            } else {
                counter.textContent = '+' + formatearNumero(target);
            }
        };
        
        updateCounter();
    }
    
    // Observador de intersección
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // Si el elemento está visible y no se ha animado aún
            if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
                entry.target.classList.add('animated');
                animarContador(entry.target);
            }
        });
    }, {
        threshold: 0.5, // Se activa cuando el 50% del elemento es visible
        rootMargin: '0px' // Ajusta si quieres que se active antes/después
    });
    
    // Observar todos los contadores
    document.querySelectorAll('.data-number').forEach(counter => {
        observer.observe(counter);
    });
});